import React from "react";
import { connect } from "react-redux";
import { formatBytes, objectToArray, truncateStringMiddle } from "utils";
import { CONTENT } from "consts";
import { ReactComponent as ImageRestoreHost } from "assets/images/app_svg/image_restore_host.svg";
import { ReactComponent as ImageRestoreDrive } from "assets/images/app_svg/image_restore_drive.svg";

function InitImgRestorePopupBody(props) {
  let diskObj = {};
  // let diskSize = {};
  const volObject = props.diskInfo.updatedVolumes.forEach(v => {
    // diskSize.hasOwnProperty([v.diskName])
    //   ? (diskSize = {
    //       ...diskSize,
    //       [v.diskName]: diskSize[v.diskName] + v.totalSize,
    //     })
    //   : (diskSize = {
    //       ...diskSize,
    //       [v.diskName]: v.totalSize,
    //     });
    props.diskInfo.checkedList.forEach(checked =>
      checked.restorePath.name === v.name
        ? diskObj.hasOwnProperty([v.diskName])
          ? (diskObj[v.diskName] = {
              ...diskObj[v.diskName],
              [v.name]: { ...v }
            })
          : (diskObj = {
              ...diskObj,
              [v.diskName]: { [v.name]: { ...v } }
            })
        : null
    );
  });

  return (
    <div className="irpopup_wrap add_svg_icon">
      <div className="tree_structure_container">
        <div className="host_wrapper">
          {Object.keys(diskObj).map((disk, k) => (
            <React.Fragment key={k}>
              <div className="host_name" key={k}>
                {" "}
                <span className="host_icon">
                  <ImageRestoreHost />
                </span>
                <span className="host_info">{disk}</span>{" "}
                {/* <span className="float_data">
                  {"(" + formatBytes(diskSize[disk]) + ")"}
                </span> */}{" "}
              </div>
              <div className="volume_container">
                <ul className="volume_table">
                  {objectToArray(diskObj[disk]).map((vol, i) => (
                    <li className="volume_row" key={i}>
                      <div className="volume_col">
                        <div className="volume">
                          <div className="volume_name">
                            <span className="svg_hard_disk_icon">
                              <ImageRestoreDrive />{" "}
                            </span>
                            <p
                              title={
                                (vol.label
                                  ? vol.label
                                  : CONTENT.restore.image.volumesList) +
                                " (" +
                                vol.name +
                                ":)"
                              }
                            >
                              {truncateStringMiddle(
                                (vol.label
                                  ? vol.label
                                  : CONTENT.restore.image.volumesList) +
                                  " (" +
                                  vol.name +
                                  ":)",
                                "select_img_container_id",
                                10,
                                150
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="used_col">
                        <div className="used_col_wrap">
                          {" "}
                          <span className="used_data">
                            {formatBytes(vol.usedSpace)}
                          </span>{" "}
                          <span className="used_info">
                            {"(" + formatBytes(vol.totalSize) + ")"}
                          </span>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    diskInfo: state.imageRestore
  };
}

export default connect(mapStateToProps)(InitImgRestorePopupBody);
